<template>
  <div class="con-vs-alert my-3 con-vs-alert-primary" v-if="dataConsolidado">
    <h4 class="titlex vs-alert--title">Consolidado</h4>
    <div class="vs-alert">
      <div>
        <span
          v-for="(item, index) in dataConsolidado.cobrancaPorApolice"
          :key="index"
        >
          Apólices: {{ item.apolice }}: {{ item.qtd }}</span
        >
        <span>Total de apólices: {{ dataConsolidado.apolices }}</span>
      </div>
      <div>
        <span
          v-for="(item, index) in dataConsolidado.cobrancaPorFormaPagamento"
          :key="index"
        >
          Forma pagamento: {{ item.pagamento }} {{ item.qtd }}</span
        >
      </div>
      <div>
        <span
          v-for="(item, index) in dataConsolidado.conbrancaPorStatus"
          :key="index"
        >
          Status de cobrança: {{ item.status_cobranca }}: {{ item.qtd }}</span
        >
      </div>
      <span>
        Valor total fechamento: {{ dataConsolidado.total | currency }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataConsolidado'],
};
</script>

<style scoped lang="scss">
span {
  display: block;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
}
</style>
